import beseapi from "./http.js";

export const beseGet = () => beseapi.get("http://demo.mms3d.net/linshi/CQ_ZM_LS3/mms3D/models/equip.json")

export const viderGet = () => beseapi.get("http://116.62.17.126:17965/d3-svr/d3data/d3_video_data")

export const moNi = () => beseapi.get('http://127.0.0.1:4523/mock/726749/user')

export default {
    beseGet,
    moNi,
    viderGet
}